import moment from "moment";

function toGermanDateTime(date: string) {
  return moment(date).format("DD.MM.YYYY HH:mm");
}

function toGermanDate(date: string) {
  return moment(date).format("DD.MM.YYYY");
}

export const dateHelper = {
  toGermanDateTime,
  toGermanDate,
}